<template>
  <div class="product-item">
    <a
      :href="url"
      class="product-item__image-wrapper"
      :title="`Product: ${title}`"
      :aria-label="`Product: ${title}`"
      style="--aspect-ratio: 1"
      @mouseover="hover = $screen.laptop_up && hoverImage"
      @mouseleave="hover = false">
      <transition name="fade">
        <VImg
          :media="activeImage"
          :fixedSize="imageSize"
          class="product-item__main-img"
          :customClass="{ lazyload: hover, 'remove-transition': lazyloaded }"
          @loaded="lazyloaded += 1"
          :key="key"
        />
      </transition>
      <VImg
        v-if="hoverImage"
        :media="hoverImage"
        :fixedSize="imageSize"
        class="product-item__hover-img"
        :customClass="{ hovering: hover, 'remove-transition': lazyloaded }"
        @loaded="lazyloaded += 1"
        :key="key"
      />
    </a>
    <div class="product-item__details-wrapper">
      <span class="product-item__title">
        {{ title }}
      </span>
      <p class="product-item__price">
        <span v-text="$money(price)"></span>
        <s v-if="salePrice" class="price--sale" v-text="$money(salePrice)"></s>
      </p>
    </div>
  </div>
</template>

<script>
import VImg from "./VImg";

export default {
  name: "ProductItem",

  components: {
    VImg,
  },

  props: ["product", "collection", "has_default_variant"],

  data() {
    return {
      key: 0,
      hover: false,
      lazyloaded: 0,
      featuredLazyLoaded: false,
      imageSize: "550x",
    };
  },

  computed: {
    title() {
      return this.product.title;
    },
    vendor() {
      return this.product.vendor;
    },
    handle() {
      return this.product.handle;
    },
    price() {
      return this.product.variants[0].price * 100;
    },
    salePrice() {
      return this.product.variants[0].compare_at_price * 100;
    },
    url() {
      return typeof this.collection !== "undefined"
        ? `/collections/${this.collection}/products/${this.handle}`
        : `/products/${this.handle}`;
    },
    images() {
      return this.product.images_info || this.product.media;
    },
    activeImage() {
      return this.images.length > 0 ? this.images[0] : null;
    },
    hoverImage() {
      return this.images.length > 1 ? this.images[1] : null;
    },
  },

  created() {
    const preloadImages = [];
    if (this.images.length)
      preloadImages.push(
        this.images[0]?.src ? this.images[0].src : this.images[0]
      );
    if (this.images.length > 1)
      preloadImages.push(
        this.images[1]?.src ? this.images[1].src : this.images[1]
      );
    this.$preloadImages(preloadImages, this.imageSize);
  },

  watch: {
    // re-render the template programmatically
    activeImage: {
      handler() {
        this.key = (Math.random() * (999 - 0 + 1)) << 0;
      },
      deep: true,
    },
  },
};
</script>
